import { render, staticRenderFns } from "./CTTRetailShop.vue?vue&type=template&id=2adfadd5"
import script from "./CTTRetailShop.vue?vue&type=script&lang=js"
export * from "./CTTRetailShop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports